module.exports = __webpack_public_path__ + "static/img/00422v.fd1ce3c.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/Images/00422v.jpg
// module id = /6Ie
// module chunks = 1